import React from "react";
import DashboardLayout from "../../../components/common/DashboardLayout";

const BulletinBoard = () => {
  return (
    <DashboardLayout>
      <div className="artist-page bulletin-board-page">
        <div className="coming-soon-container">
          <span className="coming-soon-icon">📌</span>
          <h2>Bulletin Board</h2>
          <p className="coming-soon-message">Feature coming soon</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default BulletinBoard;
